module.exports = function() {
  return new Worker(__webpack_public_path__ + "8b8b6fb72d4d367e9ce7.worker.js");
};